import { Editor, type EditorOptions } from "@tiptap/core";
import { type Accessor, createSignal, getOwner, onCleanup, onMount } from "solid-js";
import { setTipTapSolidReactiveOwner } from "./ReactiveOwner";
import { isNil } from "lodash-es";

export const createEditor = (options: Partial<EditorOptions>): Accessor<Editor | null> => {
  const [editor, setEditor] = createSignal<Editor | null>(null, {
    equals: false,
  });

  const owner = getOwner();
  if (isNil(owner)) {
    throw new Error("Owner is required");
  }

  onMount(() => {
    const instance = new Editor({
      ...options,
      onBeforeCreate: (value) => {
        setTipTapSolidReactiveOwner(value.editor, owner);
        options.onBeforeCreate?.(value);
      },
    });

    setEditor(instance);

    instance.on("transaction", () => {
      requestAnimationFrame(() => {
        setEditor(instance);
      });
    });

    onCleanup(() => {
      editor()?.destroy();
    });
  });

  return editor;
};
